interface State {
  code: string;
  displayName: string;
}

interface Transition {
  code: string;
  displayName: string;
  from: State | null;
  to: State;
}

export interface StatesAndTransitions {
  transitions: Transition[];
  states: State[];
}

export enum ConfigurationState {
  CREATED = 'CREATED',
  DELETED = 'DELETED',
  REQUESTED = 'REQUESTED',
  OFFER_CREATED = 'OFFER_CREATED',
  ORDERED = 'ORDERED',
  ARCHIVED = 'ARCHIVED',
}
export enum ProjectState {
  CREATED = 'CREATED',
  DELETED = 'DELETED',
  ARCHIVED = 'ARCHIVED',
}

interface Auditable {
  createdAt: string;
  createdAtFormatted: string;
  createdBy: string;
  createdByName: string;
  updatedAt: string;
  updatedAtFormatted: string;
  updatedBy: string;
  updatedByName: string;
}

export interface ProjectDto extends Auditable {
  id: string;
  stateName: string;
  stateCode: string;
  code: string;
  title: string;
  description: string;
  sharedWith: string[];
  customerId: string;
  assignedToId: string;
  identityDataHubId: string;
}

export interface CreateProjectDto {
  title: string;
  description: string;
}

export interface CreateConfigurationDto {
  state?: string;
  configurationId: string;
  name: string;
  rootArticleName: string;
  description: string;
}

export interface ConfigurationUpdateDto {
  name: string;
}

export interface ProjectUpdateDto {
  description: string;
  name: string;
}

export interface ConfigurationDto extends Auditable {
  id: string;
  code: string;
  name: string;
  stateCode: ConfigurationState;
  stateName: string;
  configurationId: string;
  description: string;
  rootArticleName: string;
  readonly configurationRequestId: string;
  quantity: number;
}

export type StateMachineDto = Record<string, StatesAndTransitions>;

export interface CustomerData {
  id: string;
  name: string;
  customerNumber: string;
}

export interface DuplicateConfigurationDto {
  name: string;
  rootArticleName: string;
}

export interface UserProfileDto {
  id: string;
  firstName: string;
  lastName: string;
}

export interface ConfigurationRequestDto extends SimpleProjectServiceAPI.ConfigurationRequestDto {}

export interface DraftConfigurationDto extends Auditable {
  id: string;
  rootArticleName: string;
}
